export const CANCEL = 'Cancel';
export const RESET = 'Reset';
export const APPLY = 'Apply';
